import React from "react";

const Button = ({ title }) => {
  return (
    <span className="mt-5 border border-black h-[35px] inline-flex items-center px-4 text-sm font-semibold cursor-pointer hover:text-white hover:bg-[#223746]">
      {title}
    </span>
  );
};

export default Button;
